class BrandModelPopup {
  constructor(selector = '#brand-model-popup') {
    this.popup = document.querySelector(selector);
    if (!this.popup) {
      console.warn('Brand model popup element not found');
      return;
    }

    this.closeBtn = this.popup.querySelector('.brand-model-popup-close');
    this.overlay = this.popup.querySelector('.brand-model-popup-overlay');

    this.bindEvents();
  }

  open() {
    this.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.overlay.style.display ='block';
  }

  close() {
    this.popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  handleDocumentClick(e) {
    const openButton = e.target.closest('[data-open-brand-model-popup]');
    if (openButton) {
      e.preventDefault();
      e.stopPropagation();
      this.open();
    }
  }

  handleKeyDown(e) {
    if (e.key === 'Escape' && this.popup.getAttribute('aria-hidden') === 'false') {
      this.close();
    }
  }

  bindEvents() {
    // Open popup
    document.addEventListener('click', this.handleDocumentClick.bind(this));

    // Close popup with close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.close.bind(this));
    }

    // Close when clicking overlay
    if (this.overlay) {
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new BrandModelPopup();
});
